import { useTranslation } from 'react-i18next';

import type { SeoIssue } from '@nucleus-commerce/api-client/admin';

import { isKnownEntityType, readIssueDetail } from '../schemas/issue-detail';

/** The issue's `detail` as a sentence, plus the duplicates or graph problems it lists. */
export function IssueDetailText({ issue }: { issue: SeoIssue }) {
  const { t } = useTranslation('seo');
  const view = readIssueDetail(issue);

  return (
    <div className="flex min-w-0 flex-col gap-1 text-sm">
      <span className="font-medium">{t(`code.${issue.code}`)}</span>
      <span className="text-muted-foreground break-words">
        {t(`detail.${view.messageKey}`, view.values)}
      </span>
      {view.duplicates.length > 0 ? (
        <ul className="text-muted-foreground list-disc pl-4 text-xs">
          {view.duplicates.map((duplicate) => (
            <li key={`${duplicate.entityType}:${duplicate.handle}`}>
              {isKnownEntityType(duplicate.entityType)
                ? t('detail.duplicateOf', {
                    type: t(`entityType.${duplicate.entityType}`),
                    handle: duplicate.handle,
                  })
                : duplicate.handle}
            </li>
          ))}
        </ul>
      ) : null}
      {view.graphProblems.length > 0 ? (
        <ul className="text-muted-foreground list-disc pl-4 text-xs">
          {view.graphProblems.map((problem) => (
            <li key={`${problem.path}:${problem.message}`}>
              <code className="text-[11px]">{problem.path}</code> {problem.message}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
